import { supabaseClient } from "../../config/supabase.config"
import { SUPABASE_ORGANIZATION } from "../../constants/supabase-tables"
export const getOrganizationMetadata = async (
	getToken: (
		options?: { template: string } | undefined
	) => Promise<string | null>,
	orgId: string
) => {
	const supabaseAccessToken = (await getToken({
		template: "supabase",
	})) as string
	const supabase = supabaseClient(supabaseAccessToken)
	return await supabase
		.from(SUPABASE_ORGANIZATION)
		.select("*")
		.eq("org_id", orgId)
		.single()
}
